import Azcapozalco from "../../assets/Page_Clinics/IMG_Azcapotzalco2.jpg";
import Aragon from "../../assets/Page_Clinics/IMG_Aragon2.jpg";
import Cuitlahuac from "../../assets/Page_Clinics/IMG_Cuautitlan.png";
import LasAmericas from "../../assets/Page_Clinics/IMG_LasAmericas2.jpg";
import LasFlores from "../../assets/Page_Clinics/IMG_LasFlores2.jpg";
import LaVilla from "../../assets/Page_Clinics/IMG_LaVilla.png";
import Lindavista from "../../assets/Page_Clinics/IMG_Lindavista.png";
import Miramontes from "../../assets/Page_Clinics/IMG_Miramontes2.jpg";
import ValleDorado from "../../assets/Page_Clinics/IMG_ValleDorado2.jpg";
import Atlalilco from "../../assets/Page_Clinics/IMG_Atlalilco.jpg";
import SanAntonio from "../../assets/Page_Clinics/IMG_SanAntonio.jpg";
import Coyoacan from "../../assets/Page_Clinics/IMG_Coyoacan.jpg";

export const cardClinicas = [
  {
    id: 1,
    nombre: "Hospital Coyoacán",
    img: Coyoacan,
    cp: "04030",
    lat: 19.350569232757817,
    lng: -99.15571057829759,
    direccion:
      "Calle Vicente García Torres 46, San Lucas, Coyoacán, C.P. 04030, Ciudad de México, CDMX.",
    horarios: {
      lunesViernes: "7:00-17:00 hrs",
      sabados: "8:00-13:00 hrs"
    },
    telefono: "55 1084 1400",
    servicios: [
      "Consulta de oftalmología general",
      "Inyecciones intravítreas",
      "Aplicación de láser",
      "Tomografía (OCT)",
      "Campos Visuales",
      "Óptica",
      "Farmacia"
    ]
  },
  {
    id: 2,
    nombre: "Clínica Quirúrgica Lindavista",
    img: Lindavista,
    cp: "07300",
    lat: 19.494570155534227,
    lng: -99.13404456974317,
    direccion:
      "Centro Comercial Plaza Lindavista Av. Montevideo # 363, esq. Av. Instituto Politécnico Nacional, Local 101, Col. Lindavista, Alcaldía Gustavo A. Madero, CDMX, CP 07300",
    horarios: {
      lunesViernes: "8:00-17:00 hrs",
      sabados: "8:00-13:00 hrs"
    },
    telefono: "55 1084 1400 (opción 3)",
    servicios: [
      "Cirugías",
      "Consulta de oftalmología general",
      "Inyecciones intravítreas",
      "Aplicación de láser",
      "Tomografía (OCT)",
      "Campos Visualesa",
      "Óptica",
      "Farmacia"
    ]
  },
  {
    id: 3,
    nombre: "Clínica La Villa",
    img: LaVilla,
    cp: "07820",
    lat: 19.469433211453946,
    lng: -99.11528462405768,
    direccion:
      "Chedraui Tepeyac Av. Ferrocarril Hidalgo esquina Henry Ford, Colonia tres estrellas , Alcaldía Gustavo A. Madero, C.P. 07820, Ciudad de México.",
    horarios: {
      lunesViernes: "8:00-17:00 hrs",
      sabados: "8:00-13:00 hrs"
    },
    telefono: "55 1084 1400 (opción 3)",
    servicios: [
      "Consulta de oftalmología general",
      "Inyecciones intravítreas",
      "Aplicación de láser",
      "Tomografía (OCT)",
      "Campos Visuales",
      "Óptica",
      "Farmacia"
    ]
  },
  {
    id: 4,
    nombre: "Clinica Aragon",
    img: Aragon,
    cp: "07510",
    lat: 19.468846558976953,
    lng: -99.05574813265086,
    direccion:
      "Multiplaza San Juan. Av. Central esquina Boulevard de los continentes, Fraccionamiento Bosques de Aragón, Municipio Nezahualcóyotl, CP. 07510 Estado de México.",
    horarios: {
      lunesViernes: "8:00-17:00 hrs",
      sabados: "8:00-13:00 hrs",
      domingos: "Cerrado"
    },
    telefono: "55 1084 1400 (opción 3)",
    servicios: [
      "Consulta de oftalmología general",
      "Inyecciones intravítreas",
      "Aplicación de láser",
      "Tomografía (OCT)",
      "Campos Visuales",
      "Óptica",
      "Farmacia"
    ]
  },
  {
    id: 5,
    nombre: "Clínica Miramontes",
    img: Miramontes,
    cp: "14300",
    lat: 19.29799710227411,
    lng: -99.125462703819,
    direccion:
      "Av. Canal de Miramontes número 3243 Fracc. Residencial Acoxpa, CP 14300, Alcaldía Tlalpan, Ciudad de México.",
    horarios: {
      lunesViernes: "8:00-17:00 hrs",
      sabados: "8:00-13:00 hrs"
    },
    telefono: "55 1084 1400 (opción 3)",
    servicios: [
      "Consulta de oftalmología general",
      "Inyecciones intravítreas",
      "Aplicación de láser",
      "Tomografía (OCT)",
      "Campos Visuales",
      "Óptica",
      "Farmacia"
    ]
  },
  {
    id: 6,
    nombre: "Clínica Las Américas",
    img: LasAmericas,
    cp: "55075",
    lat: 19.58078404119078,
    lng: -99.02087594614432,
    direccion:
      "Plaza Las Américas Avenida Central, Esquina 1o. de Mayo Ecatepec de Morelos, Estado de México,C.P. 55075",
    horarios: {
      lunesViernes: "8:00-17:00 hrs",
      sabados: "8:00-13:00 hrs"
    },
    telefono: "55 1084 1400 (opción 3)",
    servicios: [
      "Consulta de oftalmología general",
      "Inyecciones intravítreas",
      "Aplicación de láser",
      "Tomografía (OCT)",
      "Campos Visuales",
      "Óptica",
      "Farmacia"
    ]
  },
  {
    id: 7,
    nombre: "Clínica Valle Dorado",
    img: ValleDorado,
    cp: "54020",
    lat: 19.550061408796648,
    lng: -99.20924163264947,
    direccion:
      "Multiplaza Valle Dorado Blvd. Manuel Ávila Camacho No. 3227,Fraccionamiento Valle Dorado, CP 54020Tlalnepantla de Baz, Edo. de México",
    horarios: {
      lunesViernes: "8:00-17:00 hrs",
      sabados: "8:00-13:00 hrs"
    },
    telefono: "55 1084 1400 (opción 3)",
    servicios: [
      "Consulta de oftalmología general",
      "Inyecciones intravítreas",
      "Aplicación de láser",
      "Tomografía (OCT)",
      "Campos Visuales",
      "Óptica",
      "Farmacia"
    ]
  },
  {
    id: 8,
    nombre: "Clínica Azcapotzalco",
    img: Azcapozalco,
    cp: "02000",
    lat: 19.47890270677536,
    lng: -99.18669433633904,
    direccion:
      "Avenida Azcapotzalco No. 552, esquina Manuel Acuña, Colonia Centro de Azcapotzalco, 02000, Azcapotzalco, Ciudad de México.",
    horarios: {
      lunesViernes: "8:00-17:00 hrs",
      sabados: "8:00-13:00 hrs"
    },
    telefono: "55 1084 1400 (opción 3)",
    servicios: [
      "Consulta de oftalmología general",
      "Inyecciones intravítreas",
      "Aplicación de láser",
      "Tomografía (OCT)",
      "Campos Visuales",
      "Óptica",
      "Farmacia"
    ]
  },
  {
    id: 9,
    nombre: "Clínica Atlalilco",
    img: Atlalilco,
    cp: "09820",
    lat: 19.355711573847703,
    lng: -99.10193991242203,
    direccion:
      "Plaza Aristeum. Calzada Ermita Iztapalapa 941, Santa Isabel Industrial, Iztapalapa, C.P. 09820 CDMX.",
    horarios: {
      lunesViernes: "8:00-17:00 hrs",
      sabados: "8:00-13:00 hrs"
    },
    telefono: "55 1084 1400",
    servicios: [
      "Consulta de oftalmología general",
      "Inyecciones intravítreas",
      "Aplicación de láser",
      "Tomografía (OCT)",
      "Campos Visuales",
      "Óptica",
      "Farmacia"
    ]
  },
  {
    id: 10,
    nombre: "Clínica Las Flores",
    img: LasFlores,
    cp: "55700",
    lat: 19.63530577605245,
    lng: -99.09625551730852,
    direccion:
      "Vía José López Portillo No. 105, Col. Zacautitla Coacalco de Berriozabal, 55700, San Francisco Coacalco, Estado de México.",
    horarios: {
      lunesViernes: "8:00-17:00 hrs",
      sabados: "8:00-13:00 hrs"
    },
    telefono: "55 1084 1400 (opción 3)",
    servicios: [
      "Consulta de oftalmología general",
      "Inyecciones intravítreas",
      "Aplicación de láser",
      "Tomografía (OCT)",
      "Campos Visuales",
      "Óptica",
      "Farmacia"
    ]
  },
  {
    id: 11,
    nombre: "Clínica Cuautitlán Izcalli",
    img: Cuitlahuac,
    cp: "54730",
    lat: 19.64700686628617,
    lng: -99.20480900381291,
    direccion:
      "Centro comercial Soriana Mega Izcalli. Avenida Primero de Mayo Manzana C24 Local SA2, Col. Centro Urbano, Municipio de Cuautitlán Izcalli, C.P. 54730",
    horarios: {
      lunesViernes: "8:00-17:00 hrs",
      sabados: "8:00-13:00 hrs"
    },
    telefono: "55 1084 1400 (opción 3)",
    servicios: [
      "Consulta de oftalmología general",
      "Inyecciones intravítreas",
      "Aplicación de láser",
      "Tomografía (OCT)",
      "Campos Visuales",
      "Óptica",
      "Farmacia"
    ]
  },
  {
    id: 12,
    nombre: "Clínica San Antonio",
    img: SanAntonio,
    cp: "01180",
    lat: 19.389409909157873,
    lng: -99.19178243265227,
    direccion:
      "Plaza Exhibimex. Calle 10 No.132 Col. San Pedro de los Pinos, Álvaro Obregón, C.P. 01180, CDMX entre Boulevard Adolfo López Mateos y Ferrocarril de Cuernavaca.",
    horarios: {
      lunesViernes: "8:00-17:00 hrs",
      sabados: "8:00-13:00 hrs"
    },
    telefono: "55 1084 1400",
    servicios: [
      "Consulta de oftalmología general",
      "Inyecciones intravítreas",
      "Aplicación de láser",
      "Tomografía (OCT)",
      "Campos Visuales",
      "Óptica",
      "Farmacia"
    ]
  }
];
